// import something here
import { LoadingBar } from 'quasar'
import { Cookies, Dialog } from 'quasar'
import { Notification } from 'element-ui'
import { Loading, QSpinnerBall } from 'quasar'
import track from './tracking.js'
LoadingBar.setDefaults({
    color: 'primary',
    size: '3px',
    position: 'top',
})
const blankList = ['checkout', 'user', 'payment', '/often/goods', 'cart']
// const whiteList = ["login"];
// "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/boot-files
export default async ({ router, store, ssrContext, app } /* { app, router, Vue ... } */) => {
    // something to do
    // const cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies; // 否则我们在客户端
    const addTrack = await track({store,app})
    router.beforeEach(async (to, from, next) => {
        console.log('to', to, 'from', from)
        if (to.query.code) {
            store.apiGet('/bbb/third/auth/callBack/1001', { code: to.query.code, state: to.query.state }).then(res => {
                if (res.code != 200) {
                    next(`/login`)
                    return
                }
                if (res.data.effectToken) {
                    store.dispatch('setToken', {
                        token: res.data.token,
                        path: '/',
                    })
                } else {
                    Dialog.create({
                        title: '微信登录绑定账号',
                        message: '请输入手机号/邮箱',
                        prompt: {
                            model: '',
                            isValid: val => val.length > 0, // << here is the magic
                            type: 'text', // optional
                        },
                        cancel: '取消',
                        ok: '确定',
                        persistent: true,
                    }).onOk(data => {
                        store
                            .apiPost('/bbb/third/auth/bindUser', {
                                thirdChannel: 1001,
                                openId: res.data.openId,
                                loginAccount: data,
                            })
                            .then(res => {
                                if (res.code == 200) {
                                    store.dispatch('setToken', {
                                        token: res.data.token,
                                        path: '/',
                                    })
                                }
                            })
                    })
                }
            })
        }
        if (!process.env.SERVER && !store.state.nuxtServerInit) {
            await store.dispatch('nuxtServerInit')
        }
        if(store.state.token) {
            addTrack('page_view', {
                path: to.fullPath,
                timeField: 'pageViewTime',
                from: from.fullPath,
                userId: store.state.userInfo.userId,
            })
            addTrack('user_view', {
                path: to.fullPath,
                timeField: 'userViewTime',
                from: from.fullPath,
                userId: store.state.userInfo.userId,
            })
        }else{
            addTrack('page_view', {
                path: to.fullPath,
                timeField: 'pageViewTime',
                from: from.fullPath,
            })
        }
        if(to.name == 'goods-id') {
            addTrack('product_view', {
                path: to.fullPath,
                timeField: 'productViewTime',
                from: from.fullPath,
                goodsId: to.params.id,
                userId: store.state.userInfo.userId,
            })
        }
        Loading.hide()
        Loading.show({
            spinner: QSpinnerBall,
            backgroundColor: 'white',
            spinnerColor: 'primary',
            delay: 500, // ms
        })
        let flag = false
        blankList.forEach(item => {
            if (to.path.indexOf(item) != -1) {
                flag = true
            }
        })
        if (store.state.token) {
            if (to.path.indexOf('login') != -1) {
                next('/')
                LoadingBar.stop()
                Loading.hide()
            } else {
                next()
            }
            return
        }
        if (flag) {
            if (store.state.token) {
                next()
            } else {
                // if (to.path.indexOf('user') != -1) {
                //     LoadingBar.stop()
                //     Loading.hide()
                //     next(`/login?redirect=${to.path}`)
                //     // next(`/login`)
                //     Notification.warning({
                //         title: '请登录',
                //     })
                // } else {
                //     LoadingBar.stop()
                //     Loading.hide()
                //     next(`/login`)
                //     Notification.warning({
                //         title: '请登录',
                //     })
                // }
                LoadingBar.stop()
                Loading.hide()
                if(to.path.indexOf('/cart/checkout') != -1) {
                    next(`/login?redirect=${from.path}`)
                }else{
                    next(`/login?redirect=${to.path}`)
                }
                // next(`/login`)
                Notification.warning({
                    title: '请登录',
                })
            }
        } else {
            next()
        }
    })

    router.afterEach(async (to, from, next) => {
        LoadingBar.stop()
        Loading.hide()
    })
}
